import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DynamicPropertyRef } from '@tacliatech/types';
import { ModalAddComponent } from '@web-frontend/shared/components/add-custom-property/modal-add/modal-add.component';

import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldService {
  private refreshListSource = new Subject<boolean>();

  refreshList$ = this.refreshListSource.asObservable();

  constructor(private dialog: MatDialog) {}

  public refreshList() {
    this.refreshListSource.next(true);
  }

  open(config: { module: DynamicPropertyRef; idGroup?: string }) {
    const dialogRef = this.dialog.open(ModalAddComponent);
    dialogRef.componentInstance.type = config.module;
    dialogRef.componentInstance.idGroup = config.idGroup;

    return dialogRef.afterClosed().pipe(
      tap((res) => {
        this.refreshListSource.next(res);
      })
    );
  }
}
